// libs
import { useEffect } from "react";
import { User, LogOut, Shield } from "lucide-react";

// components
import CustomButton from "../../components/CustomButton";

// custom hooks
import useUserData from "../../hooks/useUserData";
import useToken from "../../hooks/useToken";

// styles
import classes from "./styles.module.css";

export default function ProfilePage() {
  const { userData, setUserData, fetchUserData } = useUserData();
  const [token, newToken] = useToken();

  const onLogout = () => {
    setUserData(null);
    newToken(null);
  };

  useEffect(() => {
    const isUserDataNull = !token || userData;

    if (isUserDataNull) return;
    fetchUserData(token);
  }, [token]);

  return (
    <div className={classes.root}>
      <div className={classes.banner}>
        <div className={classes.bannerUser}>
          <User size={32} />
        </div>
      </div>

      <div className={classes.content}>
        <div className={classes.userData}>
          <p>@{userData?.username}</p>
          <div className={classes.role}>
            <Shield size={14} />
            <p>{userData?.role}</p>
          </div>
        </div>

        <CustomButton className={classes.logoutButton} onClick={onLogout}>
          <LogOut size={14} />
          <span>Выйти из аккаунта</span>
        </CustomButton>
      </div>
    </div>
  );
}
